
import React, { useEffect, useState } from "react";
import { FileText, ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { DiamondBorder, SectionLabel } from "./AipanPattern";
import API_BASE_URL from "../api/api"
// const API_URL =
//   window.location.hostname === "localhost" ||
//   window.location.hostname === "127.0.0.1"
//     ? "http://127.0.0.1:8000/api/home-documents"
//     : "https://api.kunainital.ac.in/api/home-documents";
const API_URL = `${API_BASE_URL}/home-documents?limit=6`;

export default function NoticesBoard() {
  const navigate = useNavigate();

  const [active, setActive] = useState("");
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const response = await fetch(API_URL);

        if (!response.ok) {
          throw new Error(`HTTP Error: ${response.status}`);
        }

        const result = await response.json();

        if (result.status === true && Array.isArray(result.data)) {
          const activeDocuments = result.data.filter(
            (item) => Number(item.status) === 1
          );

          setDocuments(activeDocuments);

          const firstEventType = activeDocuments.find(
            (item) => item.event_type
          )?.event_type;

          if (firstEventType) {
            setActive(firstEventType);
          }
        } else {
          setDocuments([]);
        }
      } catch (error) {
        console.error("Error fetching documents:", error);
        setDocuments([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDocuments();
  }, []);

  const dynamicTabs = [
    ...new Set(
      documents.map((item) => item.event_type).filter(Boolean)
    ),
  ];

  const currentDocuments = documents
    .filter((item) => item.event_type === active)
    .slice(0, 6);

  const formatEventType = (value) => {
    if (!value) return "";

    return value
      .replace(/[-_]/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    // <section className="pt-[180px] pb-24 bg-gradient-to-b from-[var(--paper)] to-[var(--cream)] -mt-[140px]">
     <section
  id="about"
  className="relative pt-8 pb-12 bg-[var(--paper)] paper-grain"
>
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center">
          <SectionLabel>Notice Board</SectionLabel>

          {/* <h2 className="mt-1 font-display text-[38px] lg:text-[48px] font-bold">
            Stay in{" "}
            <span className="italic text-[var(--terracotta)]">
              know
            </span>
            .
          </h2> */}

          <DiamondBorder className="my-2 mx-auto max-w-md" />
        </div>

        {!loading && dynamicTabs.length > 0 && (
          <div className="mt-4 flex flex-wrap justify-center gap-2">
            {dynamicTabs.map((eventType) => {
              const isActive = eventType === active;

              return (
                <button
                  key={eventType}
                  type="button"
                  onClick={() => setActive(eventType)}
                  className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-[13.5px] font-semibold border transition-all ${
                    isActive
                      ? "bg-[var(--terracotta)] text-white border-[var(--terracotta)] shadow-lg"
                      : "bg-white text-[var(--ink)] border-[var(--cream-deep)] hover:border-[var(--terracotta)]/40"
                  }`}
                >
                  <FileText size={15} />
                  {formatEventType(eventType)}
                </button>
              );
            })}
          </div>
        )}

        <div className="mt-4 grid md:grid-cols-2 gap-4">
          {loading && (
            <div className="md:col-span-2 text-center py-4 text-gray-500">
              Loading notices...
            </div>
          )}

          {!loading && currentDocuments.length === 0 && (
            <div className="md:col-span-2 text-center py-6 text-gray-500">
              No documents available.
            </div>
          )}

          {!loading &&
            currentDocuments.map((item) => (
              <a
                key={item.id}
                href={item.pdf_path || item.external_link || "#"}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => {
                  if (!item.pdf_path && !item.external_link) {
                    e.preventDefault();
                  }
                }}
                className="group flex items-start gap-4 rounded-2xl bg-white p-5 border border-[var(--cream-deep)] card-lift hover:shadow-lg transition-all"
              >
                <div className="shrink-0 w-14 min-h-14 rounded-xl bg-[var(--terracotta)]/10 flex flex-col items-center justify-center p-1">
                  <FileText
                    size={25}
                    className="text-[var(--terracotta)]"
                  />

                  {item.publish_date && (
                    <span className="text-[10px] text-blue-500 font-bold mt-2 text-center">
                      {item.publish_date}
                    </span>
                  )}
                </div>

                <div className="h-14 w-px bg-[var(--cream-deep)] shrink-0" />

                <div className="flex-1 min-w-0">
                  <div className="text-[14.5px] leading-snug text-[var(--ink)] group-hover:text-[var(--terracotta)] transition-colors">
                    {item.heading}
                  </div>

                  <div className="mt-2 flex items-center gap-2 text-[11.5px] font-semibold text-[var(--terracotta)] opacity-80">
                    <span>{formatEventType(item.event_type)}</span>
                    <ArrowUpRight size={12} />
                  </div>
                </div>
              </a>
            ))}
        </div>

        {!loading && currentDocuments.length > 0 && (
          <div className="text-center mt-6">
            <button
              type="button"
              onClick={() =>
                navigate(
                  `/notices?tab=${encodeURIComponent(active)}`
                )
              }
              className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-[var(--terracotta)] text-white font-semibold hover:opacity-90 transition"
            >
              View All
              <ArrowUpRight size={17} />
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
